import { PropsWithChildren } from 'react';
import {
  QueryClient,
  QueryClientProvider as ReactQueryClientProvider,
} from '@tanstack/react-query';

let queryClientInstance: QueryClient | undefined;

function getQueryClient() {
  if (!queryClientInstance) {
    queryClientInstance = new QueryClient({
      defaultOptions: {
        queries: {
          retry: 1,
          refetchOnWindowFocus: false,
          staleTime: 10_000,
        },
      },
    });
  }
  return queryClientInstance;
}

export const AlmaQueryClientProvider = ({
  children,
}: PropsWithChildren<{}>) => {
  return (
    <ReactQueryClientProvider client={getQueryClient()}>
      {children}
    </ReactQueryClientProvider>
  );
};
